import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import api from '@/services/api'

export const useAuthStore = defineStore('auth', () => {
  const token = ref(localStorage.getItem('token'))
  const user = ref(JSON.parse(localStorage.getItem('user') || 'null'))
  const isAdmin = computed(() => user.value?.role === 'Administrator')

  const isAuthenticated = computed(() => !!token.value)

  const login = async (username, password) => {

    await api.get('/sanctum/csrf-cookie')

    const response = await api.post('/login', { username, password })
    const data = response
    token.value = data.token
    user.value = data.user
    
    localStorage.setItem('token', data.token)
    localStorage.setItem('user', JSON.stringify(data.user))
    
    // Update API headers
    api.defaults.headers.common['Authorization'] = `Bearer ${data.token}`
  }

  const logout = () => {
    token.value = null
    user.value = null
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    delete api.defaults.headers.common['Authorization']
  }

  const signup = async (username, password) => {
    await api.get('/sanctum/csrf-cookie')
    
    const response = await api.post('/signup', { 
      username, 
      password,
      password_confirmation: password 
    })
    
    const data = response
    token.value = data.token
    user.value = data.user
    
    localStorage.setItem('token', data.token)
    localStorage.setItem('user', JSON.stringify(data.user))
    
    api.defaults.headers.common['Authorization'] = `Bearer ${data.token}`
  }

  // Initialize API header if token exists
  if (token.value) {
    api.defaults.headers.common['Authorization'] = `Bearer ${token.value}`
  }

  return {
    token,
    user,
    isAuthenticated,
    isAdmin,
    login,
    logout,
    signup
  }
}) 